/** Label for the sole visible tab on the single-user details page */
export const SINGLE_USER_TAB_LABEL = 'User';

/** Tab strip configuration for `ntv-tabs` (mutable array for pantry input typing) */
export const SINGLE_USER_TABS: { label: string }[] = [{ label: SINGLE_USER_TAB_LABEL }];

/** Path to the shared SVG sprite used by this screen */
export const SINGLE_USER_ICONS_SPRITE_PATH = 'assets/icons/icons-sprite.svg';
